"use client";
import Icon from "@/components/icons";
import Image from "next/image";
import useTranslations from "@/i18n/useTranslations";

interface BioHeaderProps {
  imageUrl?: string;
}

export default function BioHeader({ imageUrl }: BioHeaderProps) {
  const t = useTranslations("Common");
  return (
    <div>
      <div className="h-48 bg-info-300" />
      <div className="container">
        <div
          className={
            "w-[110px] h-[110px] -mt-[52px] overflow-hidden rounded-circle d-flex align-items-center justify-content-center position-relative"
          }
        >
          {imageUrl ? (
            <div className="bg-transparent h-24 w-24 mx-auto">
              <Image
                src={imageUrl || ""}
                width={96}
                height={96}
                layout="responsive"
                className="border border-solid border-putty-300 bg-white max-w-[96px] max-h-[96px] md:max-w-[96px] md:max-h-[96px] m-0 md:m-auto rounded-full"
                alt={t("instructorPhotoAlt")}
              />
            </div>
          ) : (
            <div className="default-user">
              <Icon type="person" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
